export function auditoriaInRequest(params = {}) {
    return {
        type: '@auditoria/AUDITORIA_IN_REQUEST',
        payload: { params },
    };
}

export function failedRequest() {
    return {
        type: '@auditoria/FAILED_REQUEST',
    };
}

export function successInRequest(
    auditoria,
    page,
    pageSize,
    totalCount,
    totalPages
) {
    return {
        type: '@auditoria/SUCCESS_IN_REQUEST',
        payload: { auditoria, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(auditoria) {
    return {
        type: '@auditoria/SUCCESS_REQUEST',
        payload: { auditoria },
    };
}



export function recordFiltering(params) {
    return {
        type: '@auditoria/RECORD_FILTERING',
        payload: { params },
    };
}
